import { firebaseAction } from 'vuexfire'
import db from '@/plugins/db'
import { find, findKey } from 'lodash'
import firebase from 'firebase/app'

// initial state
const state = {
  all: {},
}

// getters
const getters = {
  getAll: (state) => () => {
    if (state.all === null) {
      return []
    }
    return Object.values(state.all)
  },
  getVisualByNumber: (state) => (visual) => {
    if (!visual) return undefined
    if (!state.all) return undefined
    return find(state.all, function (o) {
      return o.visualNumber === parseInt(visual)
    })
  },
}

// actions
const actions = {
  bindVisuals: firebaseAction(context => {
    return context.bindFirebaseRef('all', db.ref('visuals'))
  }),
  addVisual: ({ commit }, visual) => {
    visual.updatedAt = visual.updatedAt = firebase.database.ServerValue.TIMESTAMP
    db.ref('visuals').push(visual)
  },
  updateVisual: ({ commit }, visual) => {
    visual.updatedAt = firebase.database.ServerValue.TIMESTAMP
    let theKey = findKey(state.all, ['visualNumber', visual.visualNumber])
    db.ref(`visuals/${theKey}`).update(visual)
  },
  updateVisualProperty: ({ commit }, { visual, property, newVal }) => {
    let newData = {
      updatedAt: firebase.database.ServerValue.TIMESTAMP,
    }
    newData[property] = newVal
    let theKey = findKey(state.all, ['visualNumber', visual.visualNumber])
    db.ref(`visuals/${theKey}`).update(newData)
  },
}

// mutations
const mutations = {

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
